<!--
 * @Descripttion: 
 * @version: v1.0.0
 * @Author: zhoumin
 * @Date: 2020-08-21 11:42:05
 * @LastEditors: zhoumin
 * @LastEditTime: 2020-09-24 16:13:50
-->
<template>
  <div class="Personal">
    <h3>个人中心</h3>
    <div class='main'>
      <div v-if="identify==='1'"><label for="">头像：</label>
        <div class='logo'><img :src="logoUrl" alt="">
          <div @click="changeLogoCode= true">修改头像</div>
        </div>
      </div>
      <div v-if="identify==='1'">
        <label for="">姓名：</label>
        <div v-show="!edit.realname">
          {{userInfo.realname}} <i class="el-icon-edit-outline" @click="edit.realname = true"></i>
        </div>
        <div v-show="edit.realname">
          <el-input v-model="userInfo.realname" placeholder="请输入姓名"></el-input>
          <div>
            <el-button type="primary" plain @click="edit.realname = false">取消</el-button>
            <el-button type="primary" @click="submit('realname')">确认</el-button>
          </div>
        </div>
      </div>
      <div> <label for="">账号：</label> {{userInfo.username}}</div>

      <!-- <div><label for="">手机号：</label>{{userInfo.mobile}}</div> -->
      <div><label for="">密码：</label>
        <div v-show="!edit.password">
          ****** <i class="el-icon-edit-outline" @click=" edit.password = true"></i>
        </div>
        <div v-show="edit.password">
          <el-input class='password' :class='{error:password_err}' v-model="userInfo.password" type="password" placeholder="请输入密码"></el-input>
          <div>
            <el-button type="primary" plain @click="editPassword">取消</el-button>
            <el-button type="primary" @click="submit('password')">确认</el-button>
          </div>
        </div>
      </div>
      <div v-if="identify==='1'"><label for="">所属院校：</label>
        <div v-show="!edit.school">
          {{userInfo.school}} <i class="el-icon-edit-outline" @click="edit.school = true"></i>
        </div>
        <div v-show="edit.school">
          <el-input v-model="userInfo.school" placeholder="请输入所属院校"></el-input>
          <div>
            <el-button type="primary" plain @click="edit.school = false">取消</el-button>
            <el-button type="primary" @click="submit('school')">确认</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="changeLogoBox" title="编辑头像" :visible.sync="changeLogoCode" width="550px" :close-on-click-modal='false'>
      <div class="dialog_body_box">
        <Upload :show="'else'" @upload-success='getId' :fileType='fileType'>
          <div v-if="imageUrl" class='img_wrapper'>
            <img :src="imageUrl" class="avatar">
          </div>
          <div v-else class="selectImage">
            <span class='add'> <i class="el-icon-plus"></i></span>
            <div>
              支持JPG、PNG格式图片，大小不超过3M
            </div>
          </div>
        </Upload>
      </div>
      <span slot="footer">
        <el-button round type="primary" @click="changeUserNameFun"> 确定</el-button>
        <el-button round @click="changeLogoCode = false ">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from "../../api/activity/two/user/manage";
import Upload from "@components/upload";
export default {
  name: "Personal",
  components: {
    Upload
  },
  data() {
    return {
      userInfo: {},
      edit: {
        realname: false,
        password: false,
        school: false
      },
      logoUrl: "/imgs/default-people.png",
      rule: {
        pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
        message: "请输入8-16位的数字加字母",
        trigger: "blur"
      },
      imageUrl: "",
      changeLogoCode: false,
      password_err: false,
      identify: "",
      fileType: ["JPG", "PNG"]
    };
  },
  methods: {
    editPassword() {
      this.edit.password = false;
      this.userInfo.password = "";
      this.password_err = false;
    },
    getDetail() {
      api.$getDetail().then(res => {
        this.userInfo = res;
        if (res.logo) {
          if (typeof res.logo === "string") {
            res.logo = JSON.parse(res.logo);
          }
          if (res.logo[0]) {
            this.$utils.getImgUrl(res.logo[0].name).then(res => {
              this.logoUrl = res;
            });
          }
        }
      });
    },
    submit(val) {
      let next = false;
      const data = Object.assign({}, this.userInfo);
      switch (val) {
        case "password":
          if (data.password&&data.password.match(this.rule.pattern)) {
            data.password = this.$utils.Encrypt(data.password);
            next = true;
          } else {
            this.password_err = true;
          }
          break;
        default:
          data.password = "";
          next = true;
          break;
      }
      if (!next) {
        return;
      }

      api.$update(data).then(res => {
        this.$notify({
          title: "成功",
          message: "修改成功",
          type: "success"
        });
        this.userInfo.password = "";
        this.password_err = false;
        this.edit[val] = false;
        this.$store.commit("refreshUser");
      });
    },
    getId(val) {
      this.userLogoName = val.name;
      this.$utils.getImgUrl(val.name).then(r => {
        this.imageUrl = r;
      });
    },
    changeUserNameFun() {
      if(!this.userLogoName){
        this.$notify({
          title: "警告",
          message: "请上传正确的头像",
          type: "warning"
        });
        return;
      }
      this.userInfo.logo = [{ name: this.userLogoName }];
      this.changeLogoCode = false;
      this.logoUrl = this.imageUrl;
      this.submit("logo");
    }
  },
  created() {
    this.identify = localStorage.identify;
    this.getDetail();
  }
};
</script>

<style lang="scss" scoped>
.Personal {
  width: 1300px;
  margin: 0 auto;
  padding-bottom: 150px;
  h3 {
    font-size: 26px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 44px;
    color: rgba(235, 85, 79, 1);
  }
  label {
    display: inline-block;
    width: 100px;
  }
  .logo {
    position: relative;
    cursor: pointer;
    &:hover {
      > div {
        display: block;
      }
    }
    img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      vertical-align: middle;
      object-fit: cover;
      margin: 20px 0;
    }

    > div {
      position: absolute;
      top: 0;
      display: none;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      vertical-align: middle;
      margin: 20px 0;
      line-height: 80px;
      background: rgba(0, 0, 0, 0.5);
      text-align: center;
      color: #fff;
    }
  }

  .main {
    line-height: 60px;
    border: 1px solid rgba(238, 238, 238, 1);
    > div {
      padding-left: 15px;
      font-size: 16px;
      font-family: FZLanTingHeiS-R-GB;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      border-bottom: 1px solid rgba(238, 238, 238, 1);
      display: flex;
      align-items: center;
    }
  }
}

/deep/ .el-dialog__wrapper {
  .el-dialog__body {
    text-align: center;
  }

  .el-dialog__header {
    background: rgba(248, 248, 248, 1);
  }
  .el-dialog__title {
    line-height: 50px;
    padding-left: 20px;
  }
  .el-dialog__footer {
    text-align: center;
  }
  .add {
    display: inline-block;
    width: 80px;
    height: 80px;
    border: 1px dashed;
    margin-bottom: 20px;
    i {
      font-size: 30px;
      line-height: 80px;
    }
  }
}
.dialog_body_box {
  .img_wrapper {
    width: 80px;
    height: 80px;
    img {
      width: 100%;
      border-radius: 50%;
      object-fit: cover;
      height: 100%;
    }
  }
}
.error.password::after {
  content: "请输入8-16位的数字加字母";
  position: absolute;
  width: max-content;
  color: #d44d47;
  padding-left: 10px;
}
.el-icon-edit-outline {
  cursor: pointer;
}
.main{
  >div:last-child{
    border: 0;
  }
}
</style>
